export const APP_ROUTES = {
  STORY_BOARDS: "/storyboards",
  PREVIEW: "/preview", 
  NEW: "/new",
  INTRO: "/", 
  HOME: "/home", 
  ABOUT: "/about"
};
